import { api } from "./api";

export const invoiceCreateApi = (params) => {
  return api.post(`/order/add`, JSON.stringify(params));
};
export const invoiceDeleteApi = (params) => {
  return api.post(`/order/draft/delete`, JSON.stringify(params));
};
export const invoiceEditApi = (params) => {
  return api.post(`/order/draft/update`, JSON.stringify(params));
};
// Changes only the invoice discount of a finished bill (needs the "Edit Discount" permission)
export const invoiceDiscountUpdateApi = (params) => {
  return api.post(`/order/editAddedPercentageInvoice`, JSON.stringify(params));
};
export const invoiceDraftCreateApi = (params) => {
  return api.post(`/order/draft/create`, JSON.stringify(params));
};
// Holds a bill's whole cart for its billing session (see billing-reservation.js).
// Shorter timeout than the default: a lost request is resent, not waited on.
const BILLING_RESERVATION_TIMEOUT_MS = 15000;
export const billingReservationApi = (params) => {
  return api.post(`/add-or-update/commited-qty`, JSON.stringify(params), {
    timeout: BILLING_RESERVATION_TIMEOUT_MS,
  });
};
export const repeatOrderApi = (params) => {
  return api.get(
    `/order/get/repeatPastOrder?cmr_phone_number=${params?.phone}`,
    JSON.stringify(params)
  );
};

export const invoiceNumberApi = (params) => {
  return api.post(`/order/invoice`, JSON.stringify(params));
};

// The Billings list's item search (billing-item-search.js) as query params
const billItemSearchParams = (itemSearch) => {
  const searchParams = new URLSearchParams();
  if (itemSearch?.item_id) searchParams.append("filter_item_id", itemSearch.item_id);
  if (itemSearch?.item_id && itemSearch?.batch) searchParams.append("filter_batch", itemSearch.batch);
  if (itemSearch?.item_id && itemSearch?.min_qty) searchParams.append("filter_min_qty", itemSearch.min_qty);
  if (itemSearch?.phone) searchParams.append("filter_phone", itemSearch.phone);
  const query = searchParams.toString();
  return query ? `&${query}` : "";
};

// The batches an item has been billed in
export const billedItemBatchesApi = (item_id) =>
  api.get(`/order/item-batches`, { params: { item_id } });

export const invoiceTableApi = (params) => {
  return api.get(
    `/order/get?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${
      params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${
      params?.filterData?.to
    }&is_draft_order=${
      params?.filterData?.order_status === "completed"
        ? false
        : params?.filterData?.order_status === "draft"      
        ? true
        : ""
    }${
      params?.filterData?.inputValue &&
      `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }&paymentStatus=${params?.filterData?.payment_status}${billItemSearchParams(
      params?.filterData?.itemSearch
    )}`,
    JSON.stringify(params)
  );
};
export const invoicePastApi = (params) => {
  return api.get(
    `/order/pastorder/get?cmr_phone_number=${params?.phone}&pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}`,
    JSON.stringify(params)
  );
};
export const pastBillsFamilyMembersApi = (params) => {
  return api.get(
    `/pos/get-past-bills-of-users-and-family-members?phone_number=${params?.phone_number}&no_of_days=${params?.no_of_days}&pageNumber=${params?.pageNumber}`,
    JSON.stringify(params)
  );
};
export const salesItemsBySotIdApi = (params) => {
  return api.get(
    `/pos/get-sales-items-by-sot-id?sot_id=${params?.sot_id}&pageNumber=${params?.pageNumber}`,
    JSON.stringify(params)
  );
};
export const topBillsApi = (params) => {
  return api.get(
    `/order/TopBills?cmr_phone_number=${params?.cmr_phone_number}&days=${params?.days}&pageNumber=${params?.pageNumber}`,
    JSON.stringify(params)
  );
};
export const invoiceDiscountApi = (params) => {
  return api.get(
    `/discount/get?totalAmountOfItem=${params?.amount}`,
    JSON.stringify(params)
  );
};

export const invoiceViewApi = (params) => {
  return api.get(
    `/order/getOrderById?sot_id=${params}`,
    JSON.stringify(params)
  );
};
export const invoiceProductDetailsApi = (params) => {
  return api.get(
    `/product/details/getByitemIdAndBatchNumber?item_id=${params?.item_id}&item_batch_number=${params?.item_batch_number}`,
    JSON.stringify(params)
  );
};
export const invoiceAlternativeApi = (params) => {
  return api.get(
    `/product/alternative/get?item_id=${params?.alternative_id}&pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}`,
    JSON.stringify(params)
  );
};
export const storeDetailsApi = () => {
  return api.get(`/store/details/get`);
};
export const invoiceScannedItemApi = (params) => {
  return api.get(`/product/barcode/get?item_barcode=${params}`);
};

export const returnBillTableApi = (params) => {
  return api.get(
    `/order/creditNote/getall?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${
      params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${
      params?.filterData?.to
    }&is_draft_order=${
      params?.filterData?.order_status === "completed"
        ? false
        : params?.filterData?.order_status === "draft"
        ? true
        : ""
    }${
      params?.filterData?.inputValue &&
      `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }&paymentStatus=${params?.filterData?.payment_status}`,
    JSON.stringify(params)
  );
};

export const returnBillCreateApi = (params) => {
  return api.post(`/order/creditNote/add`, JSON.stringify(params));
};
export const returnBillUpdateApi = (params) => {
  return api.post(`/order/return/update`, JSON.stringify(params));
};
export const returnBillViewApi = (params) => {
  return api.get(
    `/order/creditNote/getById?icn_id=${params}`,
    JSON.stringify(params)
  );
};

export const returnBillItemsGetApi = (params) => {
  const queryString = JSON.stringify(params);
  const encodedQuery = encodeURIComponent(queryString);
  return api.get(`/order/getInvoiceItemsList?query=${encodedQuery}`);
};

export const fetchBillNumberApi = (params) => {
  return api.get(
    `/document/numbering/custom/invoice/get?backdate=${params?.backdate}&doc_type=${params?.doc_type}`
  );
};
